<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="68px">
      <el-row>
      </el-row>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini"
          @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="gap"></div>
    <div style="text-align: left; padding-left: 20px;">
      <el-button type="primary" icon="el-icon-add" :loading="loading" size="mini" @click="handleAdd">新增</el-button>
    </div>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="轮播图编号" align="center" label-class-name='title' prop="id" />
      <el-table-column label="菜单名称" align="center" label-class-name='title' prop="menuName" />
      <el-table-column label="轮播图" align="center" width="200" label-class-name='title' prop="menuUrl">
        <template slot-scope="scope">
          <div class="flex">
            <img class="img" :src='scope.row.menuUrl' referrerpolicy="no-referrer"></img>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200" label-class-name='title'
        class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button class="inspect-button" size="mini" type="primary" icon="el-icon-edit"
            @click="handleUpdate(scope.row)">修改</el-button>
          <el-button class="inspect-button" size="mini" type="danger" icon="el-icon-delete"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="total > 0" :total="total" @current-change="getList" @prev-click='getList'
      @next-click="getList" />
    <el-dialog title="轮播图新增" :visible.sync="open" :close-on-click-modal="false" width="600px" append-to-body>
      <el-form ref="form" :model="form" label-width="100px" size="mini">
        <el-row>
              <el-col :span="12">
            <el-form-item label="菜单名称" required>
              <el-input v-model="form.menuName"
                        aria-disabled
                          :disabled='disabled'
                        size="small" placeholder="请输入菜单名称" />
            </el-form-item>
          </el-col>
          
          <el-col :span="24">
            <el-form-item label="轮播图">
              <el-upload
                :action="action"
                list-type="picture-card"
                :file-list="fileList"
                :on-change="handleChange"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import config from '../config/config'
import { menusAdd, menusList, menusDelete, menusUpdate } from '../api/menu/index';
import { Notification, MessageBox, Message, Link } from "element-ui";
export default {
  name: 'Menus',    
  data () {
    return {
      fileList: [],
      limit: 2,
      baseURL: '',
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,

      list: [],
      form: {},
      open: false,
      pageIndex: 1,
      pageSize: 10,
      disabled: false,
      queryParams: {},
      loading: false,
      total: 0,
    }
  },

  created () {
    // let flag = sessionStorage.getItem('login');
    // if(!flag){
    //   this.$router.push('/')
    // }

  

    this.action = config.baseURL + '/oss/fileUpload';
    console.log(this.action)
    this.handleQuery();
  },
  methods: {
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleUpdate (row) {
      this.open = true;
      this.form = {
        menuName: row.menuName,
        id: row.id,
        menuUrl: row.menuUrl
      }
      let fileList = row.menuUrl ? [{
        response: {
          data: {
            url: row.menuUrl
          }
        },
        url: row.menuUrl
      }] : []
      this.fileList = fileList
    },
    handleDelete (row) {
      let params = {
        id: row.id,
      }
      this.$confirm('确认删除吗？')
        .then(() => {
          menusDelete(params).then(res => {
            this.$message.success('删除成功')
            this.handleQuery()
          })
        })
        .catch(_ => { });
    },
    submit () {
      let list = this.fileList.map(item=>{
        return item.response.data.url
      })
      let params = this.form;
      params.menuUrl = list.join(',');

      if(!params.menuUrl){
        return this.$message.error('请上传轮播图')
      }
    let admin = localStorage.getItem('userInfo')
    if(admin){
      admin = JSON.parse(admin)
    }

    console.log(admin)
    params.companyCode = admin.companyCode
      if (!params.id) {
        menusAdd(this.form).then(res => {
          this.$message.success('新增成功')
          this.open = false
          this.handleQuery()
        })
      } else {
        menusUpdate(this.form).then(res => {
          this.$message.success('修改成功')
          this.open = false
          this.handleQuery()
        })
      }
    },

    logout () {
      localStorage.clear();
      this.$router.push('/')
    },
    handleAdd () {
      this.open = true
      this.fileList = []
      this.form = {}
    },
    handleQuery () {
      let params = this.queryParams;
      params.pageIndex = this.pageIndex;
      params.pageSize = this.pageSize;
let admin = localStorage.getItem('userInfo')
    if(admin){
      admin = JSON.parse(admin)
    }
    params.companyCode = admin.companyCode
      this.list = []
      menusList(params).then(res => {
        console.log(res)
        this.list = res.data;
        this.total = res.data.total
      })
    },

    preClick (e) {
      this.pageIndex = e;
      if (this.pageIndex <= 1) { return }
      this.handleQuery()
    },
    preClick () {
      let pageIndex = this.pageIndex + 1;

      if (pageIndex * this.pageSize >= this.total) {
        return
      }
      this.pageIndex = pageIndex;
      this.handleQuery()
    },
    getList (e) {
      this.pageIndex = e
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }
      menusList(params).then(res => {
        this.list = res.data;
        this.total = res.data.total
      })
    }
  }
}
</script>
<style>
.app-container {
  margin-top: 40px;
}

.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}

.img{
  width: 80px;
  margin-bottom: 10px;
  height: auto;
  border: 1px solid rgb(213, 206, 206);
  box-sizing: border-box;
}
.flex{
  display: flex;
  flex-wrap: wrap;
}
.el-upload-list--picture-card .el-upload-list__item{
  width: 100px;
  height: 100px !important;
}
.el-upload--picture-card{
  width: 100px;
  height: 100px !important;
  line-height: 100px;
}
</style>


// WEBPACK FOOTER //
// src/menus/menus.vue